module.exports = __webpack_public_path__ + "static/media/premierOneCentralSeatOverMobile.8b7b13ef.svg";